/**
 * Builds a media URL for S3-hosted files
 * @param filename - The filename to encode in the URL
 * @returns The full HTTPS URL to the media file
 * @throws Error if filename is empty or NEXT_PUBLIC_S3_HOSTNAME is not configured
 */
export function buildMediaUrl(filename: string): string {
  // Validate filename is non-empty
  const trimmedFilename = filename?.trim()

  if (!trimmedFilename || trimmedFilename.length === 0) {
    throw new Error('filename is required for S3 URL generation')
  }

  const publicS3Hostname = process.env.NEXT_PUBLIC_S3_HOSTNAME

  if (!publicS3Hostname || publicS3Hostname.trim() === '') {
    throw new Error('NEXT_PUBLIC_S3_HOSTNAME is required for S3 URL generation')
  }

  const encodedFilename = encodeURIComponent(trimmedFilename)

  return `https://${publicS3Hostname}/${encodedFilename}`
}
